const SAFE_IMAGE_DATA_URL_PATTERN =
  /^data:image\/(?:png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i;

type SafeImageUrlOptions = Readonly<{
  allowDataImage?: boolean;
  allowBlobImage?: boolean;
}>;

export function normalizeHttpUrl(value: string | null | undefined) {
  const trimmedValue = value?.trim() ?? '';
  if (!trimmedValue) {
    return '';
  }

  return /^https?:\/\//i.test(trimmedValue)
    ? trimmedValue
    : `https://${trimmedValue}`;
}

export function toSafeHttpUrl(value: string | null | undefined) {
  if (!value) {
    return '';
  }

  try {
    const url = new URL(value, window.location.origin);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return '';
    }

    return url.toString();
  } catch {
    return '';
  }
}

export function toSafeImageUrl(
  value: string | null | undefined,
  options: SafeImageUrlOptions = {}
) {
  if (!value) {
    return '';
  }

  if (options.allowDataImage && SAFE_IMAGE_DATA_URL_PATTERN.test(value)) {
    return value;
  }

  if (options.allowBlobImage && value.startsWith('blob:')) {
    try {
      const blobUrl = new URL(value);
      const sourceUrl = new URL(value.slice('blob:'.length));
      const isSameOrigin = sourceUrl.origin === window.location.origin;
      const isHttpBlob = sourceUrl.protocol === 'http:' || sourceUrl.protocol === 'https:';

      if (blobUrl.protocol === 'blob:' && isSameOrigin && isHttpBlob) {
        return value;
      }
    } catch {
      return '';
    }
  }

  return toSafeHttpUrl(value);
}

export function toSafeCssImageUrl(
  value: string | null | undefined,
  options: SafeImageUrlOptions = {}
) {
  const safeUrl = toSafeImageUrl(value, options);

  return safeUrl ? `url(${JSON.stringify(safeUrl)})` : 'none';
}
